import { StaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import * as React from "react"
import NLForm from "../components/newsletter-form.js"
import ImageOne from "../images/facebook-icon.svg"
import ImageTwo from "../images/linkedin-social-icon.svg"
import P2LOGO from "../images/p2-footerlogo.svg"
import ImageThree from "../images/twitter-x-icon.svg"
import "../styles/footer.css"

const Footer = ({ data }) => {
  return (
    <>
      <section id="Footer">
        <div className="container">
          <div className="footer-top-holder">
            <div className="inner-holder">
              <div className="text">Subscribe to our newsletter</div>
              <>
                <NLForm />
              </>
            </div>
          </div>
          <div className="footer-btm-holder">
            <div className="footer-logo">
              <a className="logo" href="/">
                <img src={P2LOGO} alt="P2 Logo" />
              </a>
              <div className="footer-text">
                <a href="/keep-on-growing">keep on growing</a>
              </div>
            </div>
            <div className="footer-wrap">
              <ul className="generic">
                <li>
                  <a href="/terms-of-service">Terms of Service</a>
                </li>
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li>
                  © Copyright {new Date().getFullYear()}, Position
                  <sup>2</sup>
                </li>
              </ul>
              <ul className="social-links">
                <li className="facebook">
                  <a
                    href="http://www.facebook.com/Position2.Inc"
                    target="_blank"
                    rel="noopener"
                  >
                    <img src={ImageOne} alt="Facebook" />
                  </a>
                </li>
                <li className="linkedn">
                  <a
                    href="https://www.linkedin.com/company/position2"
                    target="_blank"
                    rel="noopener"
                  >
                    <img src={ImageTwo} alt="LinkedIn" />
                  </a>
                </li>
                <li className="twitter">
                  <a
                    href="http://twitter.com/position2/"
                    target="_blank"
                    rel="noopener"
                  >
                    <img src={ImageThree} alt="Twitter" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default function FooterBlock(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          allWpPage(filter: { id: { eq: "cG9zdDoxMjYzNg==" } }) {
            edges {
              node {
                id
                title
                singleBlockLayoutSection {
                  textArea
                }
              }
            }
          }
        }
      `}
      render={data => <Footer data={data} {...props} />}
    />
  )
}
Footer.propTypes = {
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}
